import { render } from "./CardLandscape.vue?vue&type=template&id=598a58c0"
import script from "./CardLandscape.vue?vue&type=script&lang=js"
export * from "./CardLandscape.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__